import { BASE_QUERY, COMMON_QUERY_CONFIG, ruleNewsPlus, VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG } from './shared/configs';

enum SECTION_ENUM {
  TRACKING_CONSUMERS = 'Tracking consumers'
}

const BASE = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: ['cmo today'] } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = { ...BASE, count: 2 };

const MAIN = { ...BASE, count: 4 };

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...VIDEO_WSJ_NETWORK_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'Keyword', value: 'wsj cmo network summit 2024' } }],
    not: []
  }
};

const TRACKING_CONSUMERS = {
  ...BASE_QUERY,
  query: { ...BASE_QUERY.query, or: [{ terms: { key: 'DJEThing', value: ['economy/consumers'] } }] }
};

const MORE_LIST = { ...BASE };

export { MAIN, SECTION_TOP, VIDEO, TRACKING_CONSUMERS, MORE_LIST, SECTION_ENUM };
